import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { AddIcon, ArchiveIcon, DraftsIcon } from '@treams/treams-icons';
import { Button, CardList, Jumbo, Separator, Sidebar, SidebarLayout } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';

import NoteCard from './NoteCard';
import MutualNoteCollaborators from './MutualNoteCollaborators';

export default function ViewerNotes(props: { isArchived?: boolean }) {
	const { t } = useTranslation();

	const viewer = useAuthenticatedUser();
	const userID = viewer.id;

	const collaboratorID = new URLSearchParams(useLocation().search).get('collaborator_id');

	const query = graphql.useNotesQuery({
		variables: {
			first: 10,

			filters: {
				collaboratorIDs: collaboratorID ? [collaboratorID] : [],
				isArchived: props.isArchived ?? false,
			},
		},
	});

	return (
		<SidebarLayout
			sidebar={
				<Sidebar>
					<Sidebar.Item
						small
						icon={<DraftsIcon />}
						title={t('notes.sidebar.all')}
						path="/notes"
						exact
					/>
					<MutualNoteCollaborators />
					<Sidebar.Separator />
					<Sidebar.Item
						small
						icon={<ArchiveIcon />}
						title={t('notes.sidebar.archive')}
						path="/notes/archive"
						exact
					/>
				</Sidebar>
			}
		>
			<Jumbo
				title={t('notes.index.title')}
				description={t('notes.index.description')}
				button={<Button icon={<AddIcon />} title={t('notes.index.new')} link="/notes/new" />}
			/>

			<Separator />

			<CardList
				translationName="notes.index"
				query={query}
				path="notes"
				icon={<DraftsIcon />}
				renderCard={(item: graphql.Note) => <NoteCard userID={userID} note={item} />}
				renderSkeleton={() => <NoteCard.Skeleton />}
			/>
		</SidebarLayout>
	);
}
